var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from 'pixi.js';
import { BaseDeformer } from "./BaseDeformer";
import { DEFORMER_MANIP_ENUM } from "../enums";
var TransformDeformer = /** @class */ (function (_super) {
    __extends(TransformDeformer, _super);
    function TransformDeformer() {
        var _this = _super.call(this) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.MATRIX];
        _this._transform = new PIXI.Transform();
        return _this;
    }
    TransformDeformer.prototype._uniforms = function () {
        var _a;
        // NOTE: we should probably only do this when calling updateTransform()
        this._transform.updateLocalTransform();
        return _a = {},
            _a["translationMatrix".concat(this.index)] = this._transform.localTransform.toArray(true),
            _a;
    };
    /* Vertex Shader Header definition */
    TransformDeformer.prototype._vertexHeader = function () {
        return "uniform mat3 translationMatrix".concat(this.index, ";");
    };
    /* Vertex Shader Body definition */
    TransformDeformer.prototype._vertBody = function () {
        return "mat3 getTranslationMatrix".concat(this.index, "() {\n            return translationMatrix").concat(this.index, ";\n        }\n        ");
    };
    Object.defineProperty(TransformDeformer.prototype, "position", {
        /**
         * The coordinate of the object relative to the local coordinates of the parent.
         */
        get: function () {
            return this._transform.position;
        },
        set: function (value) {
            this._transform.position.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformDeformer.prototype, "scale", {
        /**
         * The scale factors of this object along the local coordinate axes.
         * The default scale is (1, 1).
         */
        get: function () {
            return this._transform.scale;
        },
        set: function (value) {
            this._transform.scale.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransformDeformer.prototype, "rotation", {
        /**
         * The rotation of the object in radians.
         */
        get: function () {
            return this._transform.rotation;
        },
        set: function (value) {
            this._transform.rotation = value;
        },
        enumerable: false,
        configurable: true
    });
    return TransformDeformer;
}(BaseDeformer));
export { TransformDeformer };
